<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box m-h-700">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">連線列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body form-inline">
            <div class="row" v-if="roleType !== 10">
              <div class="col-xs-12 col-sm-6">
                <div class="form-group" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
                  <!-- <select class="form-control h-38" v-model="brandSelect">
                    <option v-for="brand in brandBrief" :value="brand.value">
                      {{brand.label}}
                    </option>
                  </select> -->
                  <multiselect
                    v-model="brandSelect"
                    :options="brandBrief"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="== 品牌 =="
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="value"
                  >
                  </multiselect>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 text-right">
                <div class="form-group">
                  <select class="form-control h-38" v-model="searchSelect">
                    <option value="1">名稱</option>
                  </select>
                </div>
                <div class="form-group search-bar">
                  <div class="input-group">
                    <input class="form-control" type="text" v-model="search.val">
                    <span class="input-group-addon c-pointer" @click="clickSearch()"><i class="fa fa-search"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <!--<div class="form-group" v-if="brandSelect !== 99 && brandSelect !== '99' && storeBrief.length > 1">-->
              <!--<select class="form-control h-38" v-model="storeSelect">-->
                <!--<option v-for="store in storeBrief" :value="store.value">-->
                  <!--{{store.label}}-->
                <!--</option>-->
              <!--</select>-->
            <!--</div>-->
            <!-- /.box-body -->
            <mqtt-table :brandId="brandSelect.value" :search="search"></mqtt-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import mqttTable from './Temp/MqttTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 99,
        label: '==品牌=='
      },
      storeSelect: 99,
      searchSelect: 1,
      search: {
        status: false,
        val: '',
        type: 1
      }
    }
  },
  mounted () {
  },
  components: {
    'mqtt-table': mqttTable
  },
  methods: {
    clickSearch () {
      this.search.type = this.searchSelect
      this.search.status = true
    },
    getBrandBrief (type) {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj
          }
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | MqttTable')
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0) {
              self.storeSelect = obj.value
            }
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    this.fixedH()
    this.getBrandBrief()
  },
  watch: {
    'brandSelect.value' () {
      this.getStoreBrief(this.brandSelect.value)
    }
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
</style>



// WEBPACK FOOTER //
// MqttTable.vue?48e3c236